import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { keys } from './keys';

async function fetchSpaceAISettings(spaceId: string): Promise<boolean> {
  const { data, error } = await apiClient
    .from('spaces')
    .select('is_ai_enabled')
    .eq('id', spaceId)
    .single();

  if (error) {
    throw error;
  }

  return data?.is_ai_enabled ?? true;
}

type Props = {
  spaceId?: string;
};

export function useGetSpaceAISettings(props: Props) {
  return useQuery({
    queryKey: keys.aiSettings(props.spaceId ?? ''),
    queryFn: () => fetchSpaceAISettings(props.spaceId!),
    enabled: Boolean(props.spaceId),
  });
}
